import React from 'react'
import iconDownload from "../../../../assets/img/interna/download.png";

function CardDownload({ cursoPersona, isButtonDisabledMateriales, handleDownloadMaterialesCurso, spinnerMateriales, ProgressSpinner }) {
    return (
        <div className="flex interna-material w-full mb-2 movilBackground ">
            <div className="interna-material-info ">
                <span className="subtitle text-sm h3" data-v-48f3e599="">
                    Materiales del curso
                </span>
            </div>
            <div
                className={
                    /* cursoPersona[0].idEstado != 3 &&
                        isButtonDisabledMateriales == false
                        ? */ 
                        "flex align-items-center justify-content-center interna-material-download"
                        //: "flex align-items-center justify-content-center interna-material-download-apagado"
                }
                style={{
                    width: "77px",
                    height: "100%",
                }}
                onClick={() => {
                    /* if (
                        cursoPersona[0].idEstado != 3 &&
                        isButtonDisabledMateriales == false
                    ) { */
                        handleDownloadMaterialesCurso();
                    //}
                }}
            >
                {spinnerMateriales ? (
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} />
                ) : (
                    <img src={iconDownload} width={"17.5px"} height={"21px"}></img>
                )}
            </div>

        </div>
    )
}

export default CardDownload